import script from "./moduleGoodsOutOrderPrint.vue?vue&type=script&setup=true&lang=js"
export * from "./moduleGoodsOutOrderPrint.vue?vue&type=script&setup=true&lang=js"

import "./moduleGoodsOutOrderPrint.vue?vue&type=style&index=0&id=9880cb8a&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9880cb8a"]])

export default __exports__